import { Box } from "@mui/material";
import { useMemo } from "react";
import FileInput from "./FileInput";

const ImageFileInput = ({
    id,
    value,
    onChange,
    buttonText = "Upload image",
    expectedWidth,
    expectedHeight,
    required,
}) => {
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
                const img = new window.Image();
                img.onload = () => {
                    const imgRatio = img.naturalWidth / img.naturalHeight;
                    const expectedRatio = expectedWidth / expectedHeight;
                    let scale = 1;

                    let imgX = 0, imgY = 0;

                    if (imgRatio > expectedRatio) {
                        // Image is wider than expected
                        scale = expectedWidth / img.naturalWidth;
                        imgY = (expectedHeight - img.naturalHeight * scale) / 2; // Center vertically
                    }
                    else if (imgRatio < expectedRatio) {
                        // Image is taller than expected
                        scale = expectedHeight / img.naturalHeight;
                        imgX = (expectedWidth - img.naturalWidth * scale) / 2; // Center horizontally
                    }

                    // Expand with transparent background
                    const canvas = document.createElement('canvas');
                    canvas.width = expectedWidth;
                    canvas.height = expectedHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.fillStyle = 'rgba(0,0,0,0)';
                    ctx.fillRect(0, 0, expectedWidth, expectedHeight);
                    ctx.drawImage(
                        img,
                        imgX,
                        imgY,
                        img.naturalWidth * scale,
                        img.naturalHeight * scale
                    );
                    canvas.toBlob((blob) => {
                        if (blob) {
                            //const pngFile = new File([blob], file.name.replace(/\.[^.]+$/, '.png'), { type: 'image/png' });
                            onChange(blob);
                        }
                    }, 'image/png');
                };
                img.src = ev.target.result;
            };
            reader.readAsDataURL(file);
        } else {
            onChange(null);
        }
    };

    const preview = useMemo(() => {
        if (value) {
            return URL.createObjectURL(value);
        }
        return null;
    }, [value]);

    return (
        <Box id={id} sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: '20px' }}>
            {
                preview && <img
                    src={preview}
                    alt="Preview"
                    style={{ maxWidth: "100%", objectFit: 'contain', background: 'transparent', borderRadius: 8 }}
                />
            }
            <FileInput
                buttonText={value ? "Upload another image" : `${buttonText}${required ? " *" : ""}`}
                onChange={handleFileChange}
            />
        </Box >
    );
};

export default ImageFileInput;
